export default __webpack_public_path__ + "static/media/Ilustraciya_investor-accelerator.804db118.svg";